<div class="dialog">
    <span class="title" style="font-size: 18px;">{{title}}</span>
    <div class="line"></div>
    <div class="alert-dialog-img">
      <img src="../../../assets/icons/warning.svg">
    </div>
    <div class="text alert-dialog-message">
      <div class="alert-dialog-text">{{firstMessage}}</div>
      <div class="alert-dialog-text">{{secondMessage}}</div>
      <div class="alert-dialog-text">{{thirdMessage}}</div>
      <mat-checkbox (change)="actionCheckBox($event.checked)">Li e entendi</mat-checkbox>
    </div>
    <div class="action alert-dialog-btn">
        <button
          mat-raised-button
          class="button"
          [disabled]="disabled"
          (click)="actionConfirm()"
        >
          {{ confirmButton }}
        </button>
    </div>
</div>